export type IndividualLeadFeatureSelection = {
  leadPipelineEnabled: boolean | number;
  leadContactDetailsEnabled: boolean | number;
  leadActivityTrackingEnabled: boolean | number;
};

export function individualLeadTrackingEnabled(features: IndividualLeadFeatureSelection): boolean {
  return Boolean(
    features.leadPipelineEnabled
      || features.leadContactDetailsEnabled
      || features.leadActivityTrackingEnabled,
  );
}
